import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReviewService } from '../../services/common/review-shared';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { log } from 'console';
import { DpDatepickerComponent } from '../../common-component/dp-datepicker/dp-datepicker.component';

interface selectObj {
  value: string;
  viewValue: string
}
@Component({
  selector: 'app-review-data-filter-popup',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocomplete,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatSelectModule,
    MatAutocompleteModule,
    DpDatepickerComponent
  ],
  templateUrl: './review-data-filter-popup.component.html',
  styleUrls: ['./review-data-filter-popup.component.scss', '../../../styles/_dropdown.scss']
})
export class ReviewDataFilterPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _reviewService: ReviewService,
    private route: ActivatedRoute,
    private isMobile: CommonUtilService,
    private matdialogRef: MatDialogRef<ReviewDataFilterPopupComponent>
  ) { }
  @ViewChild('auto') auto!: MatAutocomplete;
  @ViewChild('autopin') autopin!: MatAutocomplete;

  misMatchArr = [
    {id: false, name: 'No'},
    {id: true, name: 'Yes'}
  ]

  selectStatusList: selectObj[] = [
    { viewValue: 'All', value: '' },
    { viewValue: 'Active', value: 'active' },
    { viewValue: 'Inactive', value: 'inactive' },
    // {viewValue: 'Not Found', value: 'notfound'}
  ];
  dateSorting: any = [{
    viewValue: 'Ascending', value: 'asc'
  },
  {
    viewValue: 'Descending', value: 'desc'
  }]
  selectMemStatus: selectObj[] = [
    { viewValue: 'DA Approved', value: 'approved' },
    { viewValue: 'DA Rejected', value: 'rejected' },
    { viewValue: 'Review Pending', value: 'pending' },
    { viewValue: 'SU Reviewed', value: 'reviewed' },
    { viewValue: 'SU Approved', value: 'suapproved' },
    { viewValue: 'SU Rejected', value: 'surejected' },
    { viewValue: 'SU Modified', value: 'sumodified' },
    { viewValue: 'Merged', value: 'merged' },

  ];
  statusControl = new FormControl('');
  memStatus = new FormControl('');
  pin = new FormControl('');
  pincodeList: any = [];
  showAllFilter: boolean = false
  isMobileDevice: boolean = false
  fwNameList: any = [];
  daNameList: any = [];
  slNo = new FormControl('');
  fc = new FormControl('');
  fwName = new FormControl();
  daName = new FormControl()
  sort = new FormControl('')
  fromDate = new FormControl('')
  toDate = new FormControl('')
  matchId = new FormControl()

  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.matchId.setValue(this.misMatchArr[0].name)
    this.fwName.setValue('');
    this.daName.setValue('')
    if(this.data.fromDate) this.fromDate.setValue(this.data.fromDate)
    if(this.data.toDate) this.toDate.setValue(this.data.toDate)

    let queryParams = { ...this.route.snapshot.queryParams };
    if (queryParams['state'] && queryParams['district']) {
      this.showAllFilter = true
    } else
      this.slNo.setValue('')
    this.pincodeList = this.data?.pinList;
    this.fwNameList = this.data?.fw;
    this.daNameList = this.data?.da;
    console.log(this.data, this.daNameList);
    
    this.prefillData(this.data)
    this.fwName.valueChanges.subscribe((item: any) => {
      if (item.length > 0) {
        this.fwNameList = this.data.fw.filter((name: any) =>
          item?.name?.toLowerCase() === name?.name.toLowerCase() || name?.name.toLowerCase().includes(item)
        );
      } else {
        this.fwNameList = this.data.fw;
      }
    });
    this.daName.valueChanges.subscribe((item: any) => {
      if (item.length > 0) {
        this.daNameList = this.data.da.filter((name: any) =>
          item?.name?.toLowerCase() === name?.name.toLowerCase() || name?.name.toLowerCase().includes(item)
        );
      } else {
        this.daNameList = this.data.da;
      }
    });
    this.pin.valueChanges.subscribe((item: any) => {
      this.pincodeList = this.data.pin;
      if (item.length > 0 && this.data.pin.length > 0) {
        this.pincodeList = this.data.pin.filter(
          (str: string | any[]) => str === item || str.includes(item)
        );
      }
    });
  }
  displayFn(item: any): string {
    console.log(item, 'display');
    
    return item ? item.name : '';
  }
  searchDetails: any = {}
  prefillData(value: any) {
    console.log(value,'data');
    
    if (value !== undefined && this.showAllFilter) {
      if (value.status) {
        this.statusControl.setValue(value.status)
      }
      this.slNo.setValue(value.slNo !== '' ? value.slNo : '')
      this.sort.setValue(value.sortByDate !== '' ? value.sortByDate : '')
      this.memStatus.setValue(value.reviewStatus !== '' ? value.reviewStatus : '')
      this.sort.setValue(value.sortByDate !== '' ? value.sortByDate : '')
      this.pin.setValue(value.pin !== '' ? value.pin : '')
      this.fc.setValue(value.fc !== '' ? value.fc : '')
      if (value?.fwName) {
        let fw: any = this.fwNameList.filter((item: any) => item?.id === value.fwName)
        fw?.length === 1 ? this.fwName.setValue(fw[0]) : ''
        this.fwNameList = fw
      }
      if (value?.daName) {
        let da: any = this.daNameList.filter((item: any) => item?.id === value.daName)
        da?.length === 1 ? this.daName.setValue(da[0]) : ''
        this.daNameList = da
      }
    }
  }
  onSearchClick() {
    // let searchDetails = fetch
    this.matdialogRef.close(this.fetchDetailsObj());
  }
  clearSorting() {
    this.sort.setValue('')
  }
  fetchDetailsObj(): any {
    this.fc?.value ? this.searchDetails.fc = this.fc?.value : ''
    this.pin.value ? this.searchDetails.pincode = this.pin.value : ''
    this.slNo.value ? this.searchDetails.serialNumber = this.slNo.value : ''
    this.fwName?.value?.id ? this.searchDetails.updatedByFW = this.fwName?.value?.id : ''
    this.daName?.value?.id ? this.searchDetails.reviewedByDA = this.daName?.value?.id : ''
    this.statusControl?.value ? this.searchDetails.status = this.statusControl?.value : ''
    this.memStatus.value ? this.searchDetails.reviewStatus = this.memStatus.value : ''
    this.sort.value ? this.searchDetails.sortByDate = this.sort.value : ''
    this.fromDate.value ? this.searchDetails.fromDate = this.fromDate?.value : ''
    this.toDate.value ? this.searchDetails.toDate = this.toDate?.value : ''
    this.matchId?.value?.id ? this.searchDetails.mismatchRecords = this.matchId?.value.id : ''
    this.searchDetails.showAllFilter = this.showAllFilter
    // if (Object.keys(this.searchDetails).length > 1)
    //   this.searchDetails.type = true
    // else
    //   this.searchDetails.type = false
    this.searchDetails.type = true
    return this.searchDetails
    // this.searchDetails={
    //   type: true,
    //   fc: this.fc?.value ?? '',
    //   pin: this.pin.value ?? '',
    //   slNo: this.slNo.value ?? '',
    //   fwName: this.fwName?.value?.id ? this.fwName?.value?.id : '',
    //   status: this.statusControl?.value ?? '',
    //   reviewStatus: this.memStatus?.value ?? '',
    //   showAllFilter: this.showAllFilter
    // };
  }
  onClearClick() {
    this.pin.setValue('');
    this.fc.setValue('')
    this.slNo.setValue('');
    this.fwName.setValue('');
    this.statusControl.setValue('');
    this.sort.setValue('')
    this.memStatus.setValue('');
    this.pincodeList = this.data.pin;
    this.fwNameList = this.data.fw;
    this.searchDetails = {}
  }
}